// extracted by mini-css-extract-plugin
export default {"StockLocationCardList__scrollArea":"StockLocationsCardList_StockLocationCardList__scrollArea__g3YUW"};